import { Quill } from 'react-quill';
const Link = Quill.import('formats/link');

const PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

class CustomLink extends Link {
  static sanitize(url) {
    const value = super.sanitize(url);
    if (value) {
      for (const protocol of PROTOCOL_WHITELIST) if (value.startsWith(protocol)) return value;

      return `https://${value}`;
    }

    return value;
  }
}

export default CustomLink;
